import { useToast as useToastUiKit } from "@looksrare/uikit";

// @todo-yg investigate if we can remove this and just use the uikit version
export const useToast = useToastUiKit;
